import React from "react";
import {useHistory} from "react-router";
import {Navbar} from "react-bulma-components";

export default function InvoiceNav({profile, setMenuActive}){

    const { push } = useHistory();

    return(
            <Navbar.Dropdown>
              <Navbar.Item
                onClick={() => {
                  push("/invoicing");
                  setMenuActive(false);
                }}
              >
                Workshop Invoicing
              </Navbar.Item>
              <Navbar.Item
                onClick={() => {
                  push("/invoices?activeView=movement");
                  setMenuActive(false);
                }}
              >
                Movement Invoicing
              </Navbar.Item>
                <Navbar.Item
                onClick={() => {
                  push("/invoices?activeView=sales");
                  setMenuActive(false);
                }}
              >
                Vehicle Sales Invoicing
              </Navbar.Item>
                <Navbar.Item
                onClick={() => {
                  push("/invoices?activeView=order");
                  setMenuActive(false);
                }}
              >
                Parts Invoicing
              </Navbar.Item>
                <Navbar.Item
                onClick={() => {
                  push("/invoices?activeView=hire");
                  setMenuActive(false);
                }}
              >
                Hire Invoicing
              </Navbar.Item>
            </Navbar.Dropdown>
    )
}